module.exports = __webpack_public_path__ + "img/coin.ba94db83.svg";